// Images
export const DEFAULT_SERVICE_ICON_URL_GREY =
  'https://cdn.zapier.com/zapier/images/frontend/placeholder/128x128.grey.png';
export const DEFAULT_SERVICE_ICON_URL_ORANGE =
  'https://cdn.zapier.com/zapier/images/frontend/placeholder/128x128.png';
export const UPGRADE_TO_GET_BETTER_SUPPORT_CTA_HEADER =
  'https://zapier-images.imgix.net/storage/photos/1728c40b6993f25d35bd1cd39d0e9355.png';

// supportbff (contact form specific url for the support backend for frontend service)
const ZAPIER_BASE_URL = process.env.ZAPIER_BASE_URL || '';
export const SUPPORTBFF_PATH = '/api/supportbff/v1/zapier_contact_form';
export const SUPPORTBFF_URL = `${ZAPIER_BASE_URL}${SUPPORTBFF_PATH}`;

// FROM HERE KEEP IN SYNC WITH `web/backend/zapier/support/constants.py`

/** The path where we guide users to get help */
export const GET_HELP_PATH = '/app/get-help';

/** The phrasing we use when directing users to the above */
export const GET_HELP_CTA = 'get help';
